import {
    InputType,
    MainFormFields,
    WelcomeMessageFormFields,
} from '../service/bot.interface';

export const mainFormFields: MainFormFields[] = [
    {
        name: 'token',
        title: 'API токен',
        placeholder: 'Введите токен бота',
    },
];
export const welcomeMessageFormFields: WelcomeMessageFormFields[] = [
    {
        name: 'image',
        title: 'Изображение',
        placeholder: '@Spodial_Marketplace_bot',
        type: InputType.image,
    },
    {
        name: 'welcome_message',
        title: 'Текст сообщений',
        placeholder: 'Введите текст',
        type: InputType.textArea,
    },
];
